import { LucideIcon, LucideProps } from 'lucide-react';
import React, { forwardRef } from 'react';

const CalendarPlus = forwardRef<SVGSVGElement, LucideProps>(
  ({ ...props }, ref) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
      >
        <path d="M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8" />
        <path d="M16 2v4" />
        <path d="M8 2v4" />
        <path d="M3 10h18" />
        <path d="M19 16v6" />
        <path d="M16 19h6" />
      </svg>
    );
  }
);

CalendarPlus.displayName = 'CalendarPlus';

export { CalendarPlus };
export default CalendarPlus;